import paths from "../../api/paths.api";
import VendorMrqs from "../../pages/Vendor/Mrqs";
import VendorPos from "../../pages/Vendor/Pos";
import VendorDocTransmittal from "../../pages/Vendor/VendorDocTransmittal";

export const vendorRoutes = [
  {
    path: paths.vendorMrqs,
    element: <VendorMrqs />,
  },
  {
    path: paths.vendorPos,
    element: <VendorPos />,
  },
  {
    path: paths.vendorDocTransmittal,
    element: <VendorDocTransmittal />,
  },
  // {
  //   path: paths.vendorBidChat,
  //   element: <VendorBidChat />,
  // },
];
